import React, { useState, useEffect } from "react";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import "./Carousel.css";
import {
  ContainerFluid,
  MainSection,
  TitleDiv,
  CommonH2,
  SectionCenter,
  ProductImage,
  NameTitle,
  CategoryPar,
  DescPar,
  PrevButton,
  NextButton,
} from "./Carousel.elements";

function Carousel({ data }) {
  const [people, setPeople] = useState(data);
  const [index, setIndex] = React.useState(0);

  useEffect(() => {
    const lastIndex = people.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, people]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 5000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  return (
    <ContainerFluid>
      <MainSection>
        <TitleDiv>
          <CommonH2>محبوب ترین ها</CommonH2>
        </TitleDiv>
        <SectionCenter>
          {data.map((product, productIndex) => {
            const { id } = product;

            let position = "nextSlide";
            if (productIndex === index) {
              position = "activeSlide";
            }
            if (
              productIndex === index - 1 ||
              (index === 0 && productIndex === people.length - 1)
            ) {
              position = "lastSlide";
            }

            return (
              <article className={position} key={id}>
                <ProductImage src={product.image} alt={product.name} />
                <NameTitle>{product.name}</NameTitle>
                <CategoryPar>{product.category}</CategoryPar>
                <DescPar>{product.desc}</DescPar>
                <FaHeart className="icon" />
              </article>
            );
          })}
          <PrevButton onClick={() => setIndex(index - 1)}>
            <FiChevronLeft />
          </PrevButton>
          <NextButton onClick={() => setIndex(index + 1)}>
            <FiChevronRight />
          </NextButton>
        </SectionCenter>
      </MainSection>
    </ContainerFluid>
  );
}

export default Carousel;
